// BandCheck design tokens — Meridian direction
// (cool indigo + mint). Mirror of marketing/src/styles/tokens.css.
// Existing key paths (colors.primary[700], radius.sm, ...) are preserved as
// the public API and remapped onto the new palette; new keys (colors.ink,
// colors.positive, radius.lg, ...) are added alongside.

export const colors = {
  primary: {
    900: '#2341C2',
    700: '#2F53E0',
    500: '#5B78FF',
    100: '#E7ECFD',
  },
  // Legacy "secondary" slot now points at the positive/mint palette so
  // existing surfaces stop reading as warning-orange. Overbanded is good
  // news; reserve red for errors.
  secondary: {
    900: '#085C44',
    700: '#0B9B71',
    100: '#E2F6EF',
  },
  success: {
    900: '#085C44',
    700: '#0B9B71',
    100: '#E2F6EF',
  },
  error: {
    900: '#B71C1C',
    700: '#D32F2F',
    100: '#FFEBEE',
  },
  gray: {
    900: '#0F1830',
    700: '#586079',
    500: '#9AA2BB',
    300: '#E4E9F4',
    100: '#EEF2FB',
    50: '#F5F7FC',
  },
  // New Meridian named tokens.
  bg: '#F5F7FC',
  surface: '#FFFFFF',
  surface2: '#EEF2FB',
  ink: '#0F1830',
  muted: '#586079',
  faint: '#9AA2BB',
  border: '#E4E9F4',
  borderStrong: '#D4DBEC',
  positive: '#0B9B71',
  positiveSoft: '#E2F6EF',
  positiveInk: '#085C44',
  accent2: '#5B78FF',
} as const

export const space = {
  4: 4,
  8: 8,
  16: 16,
  24: 24,
  32: 32,
  48: 48,
  64: 64,
} as const

export const radius = {
  sm: 10,
  md: 12,
  lg: 16,
  pill: 999,
} as const

export const fontSize = {
  hero: 38,
  h1: 28,
  h2: 24,
  h3: 21,
  h4: 19,
  body: 16,
  small: 14,
  tiny: 13,
  micro: 11.5,
} as const

export const fontWeight = {
  black: '800',
  bold: '700',
  semibold: '600',
  medium: '500',
  regular: '400',
} as const

export const fontFamily = {
  body: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  // Editorial serif display layer (loaded on web by installEditorialFont;
  // native falls back to Georgia). Used for big figures + display headings.
  serif: 'Newsreader, Georgia, "Times New Roman", serif',
  mono: '"JetBrains Mono", "SF Mono", Menlo, Consolas, "Courier New", monospace',
} as const

export const shadow = {
  card: {
    shadowColor: '#0F1830',
    shadowOffset: { width: 0, height: 12 },
    shadowOpacity: 0.18,
    shadowRadius: 28,
    elevation: 8,
  },
  subtle: {
    shadowColor: '#0F1830',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 10,
    elevation: 2,
  },
} as const
